import { useMemo, useState } from "react";
import { Col, Collapse, Row, Spinner, DropdownButton,Dropdown, Form } from "react-bootstrap";
import { SubmitResetButton1} from "../../Client/ClientUtil";
import { axiosPutWithHeader, ShowGenericAlertError } from "../../Common/axios";

export function DestinyAnalyser ({menuArray,userData,clientData,eventData,handleEventKey,handleEventData}) {
  const [spinner, setSpinner] = useState('Loading - Destiny Anayser');
  const [supportiveDestinyCategory,setSupportiveDestinyCategory] = useState([0]);
  const [opposingDestinyCategory,setOpposingDestinyCategory] = useState([0]);
  const [eventCategoryValues,setEventCategoryValues]=useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [msgtitle, setMsgtitle] = useState('Error');
  const [msgbody, setMsgbody] = useState('');
  const [msgbutton, setMsgbutton] = useState('');

  const handleAlertCallback = ()=>{
    setErrorMessage(null);
  }

  const handleEvents = (key)=> {
    handleEventKey(key);
  }
  useMemo(() => {
    if(eventData!==null && eventData.supportiveDestiny!==null && eventData.supportiveDestiny!==undefined){
      var supCategory = Array(eventData.supportiveDestiny.length).fill(0);
      var supArray=[];
      if(eventData.userEvent!==null && eventData.userEvent.supportiveDestinyCategory!==null) {
        supArray = eventData.userEvent.supportiveDestinyCategory.split(",");
      }
      for(var i=0; i<supCategory.length && i<supArray.length; i++) {
        supCategory[i] = supArray[i];
      }
      setSupportiveDestinyCategory(supCategory);
    } else {
      setSupportiveDestinyCategory([]);
    }

    if(eventData!==null && eventData.opposingDestiny!==null && eventData.opposingDestiny!==undefined){
      var oppCategory = Array(eventData.opposingDestiny.length).fill(0);
      var oppArray=[];
      if(eventData.userEvent!==null && eventData.userEvent.opposingDestinyCategory!==null) {
        oppArray = eventData.userEvent.opposingDestinyCategory.split(",");
      }
      for(i=0; i<oppCategory.length && i<oppArray.length; i++) {
        oppCategory[i] = oppArray[i];
      }
      setOpposingDestinyCategory(oppCategory);
    } else {
      setOpposingDestinyCategory([]);
    }

    if(eventData!==null && eventData.currentEvent!==null) {
      setEventCategoryValues([
          eventData.currentEvent.primary,eventData.currentEvent.secondary,eventData.currentEvent.supportive,
          eventData.currentEvent.bad,eventData.currentEvent.worse,eventData.currentEvent.worst
       ]);
    }
      setSpinner(null);
  }, [eventData]);
  
  function handleColorInput(event,planetIndex){
    const tempSupportiveDestinyCategory = [...supportiveDestinyCategory];
    tempSupportiveDestinyCategory[planetIndex]=event.target.value;
    setSupportiveDestinyCategory(tempSupportiveDestinyCategory);
  }

  function handleOpposingInput(event,planetIndex){
    const tempOpposingDestinyCategory = [...opposingDestinyCategory];
    tempOpposingDestinyCategory[planetIndex]=event.target.value;
    setOpposingDestinyCategory(tempOpposingDestinyCategory);
  }

  function getTag(str){
    if(str===null||str==="") return "";
    var arr = str.split("/");
    for(var i=0; i<arr.length;i++) {
      if(arr[i]===null||arr[i]==="") continue;
      if(i===0) {
        arr[i]=<font color={getColor(arr[i])}><b>{arr[i]}</b></font>;
      } else {
        arr[i]=<>, <font color={getColor(arr[i])}><b>{arr[i]}</b></font></>;
      } 
    }
    return arr;
  }

  function getColor(value){
    if(value===null||eventData===null||eventData.currentEvent===null||eventData.allEventCategoryColor===null){
      return "black";
    }
    value = value.trim();

    for(var i=0; eventCategoryValues!==null && i<eventCategoryValues.length; i++){
      if(isExistinArray(eventCategoryValues[i],value)) {
        return eventData.allEventCategoryColor[i];
      }
    }
    return "black";
  }

  function isExistinArray(str,value) {
    if(str===null||str===undefined) return false;
    var array = str.split(",");
    for(var i=0;i<array.length;i++) {
      if(array[i].toString()===value) {
        return true;
      }
    }
    return false;
  }

  const handleSubmit =  (event) => {
    const data = {
      userId:userData.id,
      eventId: eventData.currentEvent.id,
      supportiveDestinyCategory: supportiveDestinyCategory.toString(),
      opposingDestinyCategory: opposingDestinyCategory.toString(),
    };
    axiosPutWithHeader("/chart/event/destiny", data,
      (response)=>{
        setMsgtitle("Destiny");
        setMsgbutton("Close");
        if(response.data.code==='200') {
          handleEventData(userData.id,eventData.currentEvent.id);
          setMsgbody("Destiny values updated successfully.");
        } else {
          setMsgbody("Error occurred while saving Destiny.");
        }
        setErrorMessage("Error");
      },
      (error)=>{
        setMsgtitle("Error");
        setMsgbody("Error occurred while saving");
        setMsgbutton("Close");
        setErrorMessage(error.message);
      }
    );      
    event.preventDefault();
  }

  function handleReset() {
    if(eventData!==null && eventData.supportiveDestiny!==null && eventData.supportiveDestiny!==undefined){
      var supCategory = Array(eventData.supportiveDestiny.length).fill(0);
      var supArray=[];
      if(eventData.userEvent!==null && eventData.userEvent.supportiveDestinyCategory!==null) {
        supArray = eventData.userEvent.supportiveDestinyCategory.split(",");
      }
      for(var i=0; i<supCategory.length && i<supArray.length; i++) {
        supCategory[i] = supArray[i];
      }
      setSupportiveDestinyCategory(supCategory);
    } else {
      setSupportiveDestinyCategory([]);
    }

    if(eventData!==null && eventData.opposingDestiny!==null && eventData.opposingDestiny!==undefined){
      var oppCategory = Array(eventData.opposingDestiny.length).fill(0);
      var oppArray=[];
      if(eventData.userEvent!==null && eventData.userEvent.opposingDestinyCategory!==null) {
        oppArray = eventData.userEvent.opposingDestinyCategory.split(",");
      }
      for(i=0; i<oppCategory.length && i<oppArray.length; i++) {
        oppCategory[i] = oppArray[i];
      }
      setOpposingDestinyCategory(oppCategory);
    } else {
      setOpposingDestinyCategory([]);
    }
  }

  return(<>
    {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
    { eventData===null || eventData===undefined || eventData.length===0 || userData===null || userData===undefined
          || clientData===null || clientData===undefined ?<></>:
      <Collapse in={menuArray[1]} className="m-0 p-0">
        <Row id="eventAnalyserChart" className="m-0 p-0">
          <Col xs={12} className="p-0 m-0 pt-1">
            <Row id="destiny" className="m-0 p-0">
              <Col xs={0} lg={3} className="m-0 p-0">
                <table class="table table-hover align-middle caption-top m-0 p-0 text-center TableFont11">
                  <caption class="m-0 p-0 ps-2 pt-2"><h5 class="m-0 p-0">Destiny Analyser</h5></caption>
                </table>
              </Col>
              <Col xs={12} lg={6} className="p-0 m-0 text-center">
                <Row id="heading" className="m-0 p-0">
                  <Col xs={0} lg={3} className="p-0 m-0 text-start">
                    <DropdownButton id="dropdown-basic-button" title={eventData.currentEvent.name} variant="light" class="m-0 p-0 me-2">
                      <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                      {Object.keys(eventData.allEvents).map((key, index) => {
                        const event = eventData.allEvents[key];
                        return Object.keys(event).map((key) => {
                          const value = event[key];
                          if(key<0) {
                            return <Dropdown.Divider/>
                          }
                          return <Dropdown.Item onClick={()=>handleEvents(key)} >{value}</Dropdown.Item>
                        })  
                      })}
                      </div>
                    </DropdownButton>
                  </Col>
                  <Col xs={0} lg={9} className="p-0 pt-0 m-0">
                  <div class="input-group m-0 p-0">
                    <input type="input" maxlength="10" class="form-control" title="Primary" value={eventData.currentEvent.primary===null?"":eventData.currentEvent.primary}/>
                    <input type="input" maxlength="10" class="form-control" title="Secondary" value={eventData.currentEvent.secondary===null?"":eventData.currentEvent.secondary}/>
                    <input type="input" maxlength="10" class="form-control" title="Supportive" value={eventData.currentEvent.supportive===null?"":eventData.currentEvent.supportive} />
                    <input type="input" maxlength="10" class="form-control" title="Bad" value={eventData.currentEvent.bad===null?"":eventData.currentEvent.bad}/>
                    <input type="input" maxlength="10" class="form-control" title="worse" value={eventData.currentEvent.worse===null?"":eventData.currentEvent.worse} />
                    <input type="input" maxlength="10" class="form-control" title="Worst" value={eventData.currentEvent.worst===null?"":eventData.currentEvent.worst} />
                  </div>
                  </Col>    
                </Row>
              </Col>
              <Col xs={0} lg={3} className="m-0 p-0"></Col>
            </Row>

            <form method="post" onSubmit={handleSubmit}>
            <Row id="destiny1" className="m-0 p-0">
              <Col xs={12} lg={6} className="m-0 p-1 pt-2">
              { 
                eventData.supportiveDestiny===null?<>
                <table class="table table-bordered table-hover align-middle caption-top p-0 m-0 text-center TableFont">
                  <caption class="p-0 m-0"><h6 class="p-2 pt-3 m-0 text-center text-info">No Supportive Destiny for this event</h6></caption>
                </table>  
                </>:
                eventData.supportiveDestiny.map((destiny,destinyIndex) => (
                <table class="table table-bordered table-hover align-middle caption-top p-0 m-0 text-center TableFont">
                  <caption class="p-0 m-0"><h6 class="p-2 pt-3 m-0 text-center text-info"><b>Supportive Destiny : </b>{destiny}  <b>SubLord : </b>{eventData.supportiveDestinyPlanet[destinyIndex]}</h6></caption>
                  <thead>
                    <tr class="m-0 p-0" >
                      <th class="m-0 p-1 align-middle"></th> 
                      <th class="m-0 p-1 align-middle">Planet</th> 
                      <th class="m-0 p-1 align-middle">CL</th> 
                      <th class="m-0 p-1 align-middle">OCC</th> 
                      <th class="m-0 p-1 align-middle">CST</th> 
                      <th class="m-0 p-1 align-middle" >CSL</th> 
                      <th class="m-0 p-1 align-middle" >Result</th> 
                    </tr>
                  </thead>
                  <tbody>
                  { eventData.supportiveEventDestiny!==null && eventData.supportiveEventDestiny.length!==0 &&
                      eventData.supportiveEventDestiny[destinyIndex]!==null &&
                      eventData.supportiveEventDestiny[destinyIndex].map((planet,planetIndex) => (
                    planet===null?<></>:
                    <>
                      <tr class={planet.split(',')[0]!=="2"&&planet.split(',')[0]!=="4"?"p-0 bg-light":"p-0"} style={planet.split(',')[1]==="2"?{"border-bottom": 'none'}:planet.split(',')[1]==="0"?{"border-top": 'none'}:{}} >
                        <th class="bg-transparent text-start m-0 p-0 pt-1 ps-2">{planet.split(',')[2]}</th>
                        <td class="text-start m-0 p-0 pt-1 ps-2 kptable-td" style={{'background-color':planet.split(',')[9], 'color':planet.split(',')[10]}}>{planet.split(',')[3]}</td>
                        <td class="bg-transparent text-start m-0 p-0 pt-1 ps-2 kptable-td text-nowrap">{getTag(planet.split(',')[4])}</td>
                        <td class="bg-transparent text-start m-0 p-0 pt-1 ps-2 kptable-td text-nowrap">{getTag(planet.split(',')[5])}</td>
                        <td class="bg-transparent text-start m-0 p-0 pt-1 ps-2 kptable-td text-nowrap">{getTag(planet.split(',')[6])}</td>
                        <td class="bg-transparent text-start m-0 p-0 pt-1 ps-2 kptable-td text-nowrap">{getTag(planet.split(',')[7])}</td>
                        <td class="bg-transparent text-start m-0 p-0 pt-1 ps-2 kptable-td">{planet.split(',')[8]===""?"":eventData.allPlanetCategory[planet.split(',')[8]][0]}</td>
                      </tr>
                    </>
                  ))}
                  </tbody>
                  <thead>
                    <tr class="m-0 p-0" >
                      <th colSpan="5" class="m-0 p-1 align-middle text-end">Destiny Result</th> 
                      <td colSpan="2" class="bg-transparent text-center m-0 p-1 ps-2 kptable-td">
                        {supportiveDestinyCategory.length<=destinyIndex 
                            || eventData.allPlanetCategory[supportiveDestinyCategory[destinyIndex]]===null
                            || eventData.allPlanetCategory[supportiveDestinyCategory[destinyIndex]]===undefined ?<></>:
                          <Form.Select class="bg-transparent m-0 p-1 border-0" name={"destiny"+destinyIndex} value={supportiveDestinyCategory[destinyIndex]} style={{backgroundColor:eventData.allPlanetCategory[supportiveDestinyCategory[destinyIndex]][2], color:eventData.allPlanetCategory[supportiveDestinyCategory[destinyIndex]][3] }} onChange={(event)=>handleColorInput(event,destinyIndex)} >
                          {eventData.allPlanetCategory.map((category,index) => (
                            <option key={index} value={index} class="text-start m-0 p-0" style={{backgroundColor:category[2], color:category[3] }} >{category[0]}</option>
                          ))}
                          </Form.Select>
                        }
                      </td>
                    </tr>
                  </thead>
                </table>
              )) }
              </Col>

              <Col xs={12} lg={6} className="m-0 p-1 pt-2">
              { 
                eventData.opposingDestiny===null?<>
                <table class="table table-bordered table-hover align-middle caption-top p-0 m-0 text-center TableFont">
                  <caption class="p-0 m-0"><h6 class="p-2 pt-3 m-0 text-center text-info">No Opposive Destiny for this event</h6></caption>
                </table>  
                </>:
                eventData.opposingDestiny.map((destiny,destinyIndex) => (
                <table class="table table-bordered table-hover align-middle caption-top p-0 m-0 text-center TableFont">
                  <caption class="p-0 m-0"><h6 class="p-2 pt-3 m-0 text-center text-info"><b>Opposive Destiny : </b>{destiny}  <b>SubLord : </b>{eventData.opposingDestinyPlanet[destinyIndex]}</h6></caption>
                  <thead>
                    <tr class="m-0 p-0" >
                      <th class="m-0 p-1 align-middle"></th> 
                      <th class="m-0 p-1 align-middle">Planet</th> 
                      <th class="m-0 p-1 align-middle">CL</th> 
                      <th class="m-0 p-1 align-middle">OCC</th> 
                      <th class="m-0 p-1 align-middle">CST</th> 
                      <th class="m-0 p-1 align-middle" >CSL</th> 
                      <th class="m-0 p-1 align-middle" >Result</th> 
                    </tr>
                  </thead>
                  <tbody>
                  { eventData.opposingEventDestiny!==null && eventData.opposingEventDestiny.length!==0 &&
                      eventData.opposingEventDestiny[destinyIndex]!==null &&
                      eventData.opposingEventDestiny[destinyIndex].map((planet,planetIndex) => (
                    planet===null?<></>:
                    <>
                      <tr class={planet.split(',')[0]!=="2"&&planet.split(',')[0]!=="4"?"p-0 bg-light":"p-0"} style={planet.split(',')[1]==="2"?{"border-bottom": 'none'}:planet.split(',')[1]==="0"?{"border-top": 'none'}:{}}>
                        <th class="bg-transparent text-start m-0 p-0 pt-1 ps-2">{planet.split(',')[2]}</th>
                        <td class="text-start m-0 p-0 pt-1 ps-2 kptable-td" style={{'background-color':planet.split(',')[9], 'color':planet.split(',')[10]}}>{planet.split(',')[3]}</td>
                        <td class="bg-transparent text-start m-0 p-0 pt-1 ps-2 kptable-td text-nowrap">{getTag(planet.split(',')[4])}</td>
                        <td class="bg-transparent text-start m-0 p-0 pt-1 ps-2 kptable-td text-nowrap">{getTag(planet.split(',')[5])}</td>
                        <td class="bg-transparent text-start m-0 p-0 pt-1 ps-2 kptable-td text-nowrap">{getTag(planet.split(',')[6])}</td>
                        <td class="bg-transparent text-start m-0 p-0 pt-1 ps-2 kptable-td text-nowrap">{getTag(planet.split(',')[7])}</td>
                        <td class="bg-transparent text-start m-0 p-0 pt-1 ps-2 kptable-td">{planet.split(',')[8]===""?"":eventData.allPlanetCategory[planet.split(',')[8]][0]}</td>
                      </tr>
                    </>
                  ))}
                  </tbody>
                  <thead>
                    <tr class="m-0 p-0" >
                      <th colSpan="5" class="m-0 p-1 align-middle text-end">Destiny Result</th> 
                      <td colSpan="2" class="bg-transparent text-center m-0 p-1 ps-2 kptable-td">
                        {opposingDestinyCategory.length<=destinyIndex 
                            || eventData.allPlanetCategory[opposingDestinyCategory[destinyIndex]]===null
                            || eventData.allPlanetCategory[opposingDestinyCategory[destinyIndex]]===undefined ?<></>:
                          <Form.Select class="bg-transparent m-0 p-1 border-0" name={"destiny"+destinyIndex} value={opposingDestinyCategory[destinyIndex]} style={{backgroundColor:eventData.allPlanetCategory[opposingDestinyCategory[destinyIndex]][2], color:eventData.allPlanetCategory[opposingDestinyCategory[destinyIndex]][3] }} onChange={(event)=>handleOpposingInput(event,destinyIndex)} >
                          {eventData.allPlanetCategory.map((category,index) => (
                            <option key={index} value={index} class="text-start m-0 p-0" style={{backgroundColor:category[2], color:category[3] }} >{category[0]}</option>
                          ))}
                          </Form.Select>
                        }
                      </td>
                    </tr>
                  </thead>
                </table>
              )) }
              </Col>
            </Row>

            <Row id="significators" className="m-0 p-0 pt-3">
              <Col xs={12} lg={3} className="m-0 p-0"></Col>
              <Col xs={12} lg={6} className="m-0 p-0 text-center">
                <SubmitResetButton1 callback={handleReset} /> 
              </Col>
              <Col xs={12} lg={3} className="m-0 p-0"></Col>
            </Row>
            </form>
          </Col>
        </Row>
      </Collapse>
    }
    <ShowGenericAlertError errorAlert={errorMessage} setErrorAlert={setErrorMessage} msgtitle={msgtitle}
        msgbody={msgbody} msgbutton={msgbutton} callback={handleAlertCallback}/>
  </>
  );
}